module.exports = {
	RECEIVE_POINT: 'RECEIVE_POINT',
	RECEIVE_POINT_KEY_FIGURES: 'RECEIVE_POINT_KEY_FIGURES',
	RECEIVE_POINT_NETWORKS: 'RECEIVE_POINT_NETWORKS',
	RECEIVE_SAMPLING_SURFACE_POINT: 'RECEIVE_SAMPLING_SURFACE_POINT',
	PANEL_QUALITY_ANALYSIS: 'PANEL_QUALITY_ANALYSIS',
	PANEL_QUALITY_SAMPLING_POINTS: 'PANEL_QUALITY_SAMPLING_POINTS',
	RESET_POINT_INFORMATIONS: 'RESET_POINT_INFORMATIONS'
}



// WEBPACK FOOTER //
// ./src/point/constants/PointConstants.js